import React from 'react'
import "../Footer/footer.css"
const Footer = () => {
  return (
    <div className='footer'>
    <h1>@2024 All rights reserved.</h1>
    </div>
  )
}

export default Footer;
